import { render, staticRenderFns } from "./InspectorPanel.vue?vue&type=template&id=06a06fc0&"
import script from "./InspectorPanel.vue?vue&type=script&lang=js&"
export * from "./InspectorPanel.vue?vue&type=script&lang=js&"
import style0 from "./InspectorPanel.vue?vue&type=style&index=0&id=06a06fc0&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports